import { Fragment } from "react";
import { SignUpData } from "../../../Data/Authentication/Authentication";

const TermsCondition: React.FC<{ socialLinks?: boolean }> = ({ socialLinks }) => {
  return (
    <Fragment>
      <p className="text-center">{"Send an SMS code to verify your number"}</p>
      {socialLinks && (
        <div className="medialogo mb-4">
          <ul className="d-flex align-items-center justify-content-center gap-3">
            {SignUpData.map((item, index) => (
              <li key={index}>
                <a className={`icon-btn btn-${item.color} button-effect`} href={item.url}>
                  <i className={`fa fa-${item.icon}`} />
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}
      <div className="termscondition pt-3">
        <p className="mb-1 text-center">{"By moving forward, you concur with the"}</p>
        <h4 className="mb-0 text-center font-primary">{" Terms & condition - Privacy policy"}</h4>
      </div>
    </Fragment>
  );
};

export default TermsCondition;
